<template>
  <el-dialog
    class=""
    :visible.sync="showDialog"
    :before-close="handleClose"
    :width="breakpoints.lgAndUp ? '50%' : '85%'"
    top="9vh"
    custom-class="custom-scrollable"
  >
    <torus-mara-contract />
    <div class="flex justify-center items-center mt-8">
      <o-button class="w-48 font-semibold hover:opacity-80" @click="handleClose"
        >I understand</o-button
      >
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'TorusMaraTermsOfService',
  components: {
    TorusMaraContract: () =>
      import('@/components/settings/TorusMaraContract.vue')
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      scrollPosition: 0
    }
  },
  methods: {
    handleScroll (e) {
      this.scrollPosition = e.target.scrollTop
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 10px;
  height: 640px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  opacity: 0.9;
}
</style>
<style lang="scss">
@import '@/assets/_shared.scss';
</style>
